const plans = [
  {
    id: 'starter',
    name: 'Starter',
    price: '300,000',
    unit: '〜',
    lead: '小規模開発・部分的なご依頼に',
    features: [
      'Webサイト制作（5ページまで）',
      'シンプルなシステム開発',
      '基本的なUIデザイン',
      'メールサポート',
      '納品後1ヶ月間の軽微な修正対応',
    ],
    highlighted: false,
  },
  {
    id: 'professional',
    name: 'Professional',
    price: '800,000',
    unit: '〜',
    lead: '本格的な開発プロジェクトに',
    features: [
      'Webサイト・Webアプリ開発（上限なし）',
      'システムの企画設計から実装まで',
      '高度なUI/UXデザイン',
      'チャット＋電話サポート',
      '納品後3ヶ月間の保守対応',
      'SEO対策・パフォーマンス最適化',
    ],
    highlighted: true,
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    price: '2,000,000',
    unit: '〜',
    lead: '大規模案件・継続的な開発に',
    features: [
      '大規模システムのフルスクラッチ開発',
      'ITコンサルティング込み',
      '専任デザイナー＋エンジニアチーム',
      '24時間優先サポート',
      '納品後6ヶ月間の手厚い保守対応',
      '継続的な改善提案と運用支援',
      '専用プロジェクト管理',
    ],
    highlighted: false,
  },
];

export default function PricingSection() {
  return (
    <section id="pricing" className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="mb-16 md:mb-20">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium tracking-[0.2em] mb-5">
            PRICING
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-light text-foreground-900 tracking-wide">
            料金案内
          </h2>
          <p className="text-foreground-500 text-sm mt-4 max-w-lg">
            すべてのプランはお客様のご要望に応じてカスタマイズ可能です。まずはお気軽にご相談ください。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {plans.map((plan) => (
            <div
              key={plan.id}
              className={`relative rounded-2xl p-6 md:p-8 flex flex-col transition-all duration-300 ${
                plan.highlighted
                  ? 'bg-foreground-900 text-white ring-2 ring-primary-400 scale-[1.02] md:scale-105'
                  : 'bg-background-50 border border-background-200/80 hover:border-background-300'
              }`}
            >
              {plan.highlighted && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full bg-primary-500 text-white text-xs font-medium tracking-wider whitespace-nowrap">
                  RECOMMENDED
                </span>
              )}

              <div className="mb-6">
                <h3
                  className={`font-heading text-xl font-light tracking-wide mb-1 ${
                    plan.highlighted ? 'text-white/80' : 'text-foreground-500'
                  }`}
                >
                  {plan.name}
                </h3>
                <div className="flex items-baseline gap-1">
                  <span className="text-sm">¥</span>
                  <span className={`font-heading text-4xl md:text-5xl font-light tracking-tight ${
                    plan.highlighted ? 'text-white' : 'text-foreground-900'
                  }`}>
                    {plan.price}
                  </span>
                  <span className={`text-sm ${
                    plan.highlighted ? 'text-white/60' : 'text-foreground-400'
                  }`}>
                    {plan.unit}
                  </span>
                </div>
                <p className={`text-sm mt-2 ${
                  plan.highlighted ? 'text-white/60' : 'text-foreground-500'
                }`}>
                  {plan.lead}
                </p>
              </div>

              <ul className="flex-1 space-y-3 mb-8">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3 text-sm">
                    <span className={`mt-0.5 shrink-0 ${
                      plan.highlighted ? 'text-primary-400' : 'text-accent-500'
                    }`}>
                      <i className="ri-check-line"></i>
                    </span>
                    <span className={
                      plan.highlighted ? 'text-white/80' : 'text-foreground-600'
                    }>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>

              <a
                href="#contact"
                className={`block text-center py-3 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  plan.highlighted
                    ? 'bg-primary-500 text-white hover:bg-primary-400'
                    : 'bg-foreground-900 text-background-50 hover:bg-foreground-800'
                }`}
              >
                お問い合わせ
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}